export default "__VITE_ASSET__VJB0VLM7__"